<script>
    import { tick } from "svelte";
    import { saveCampaignFlow, genBonusIdV2 } from "../../../utils/freebetsIgp.js";
    import { makeEmptyCampaign, addToEnd as coreAddToEnd, mapRowToPlayersCampaign } from "../../../utils/freebetsCore.js";
    import { CampaignAPI } from "../../../utils/freebetsApi.js";
    import CreateCampainIgp from "./CreateCampainIgp.svelte";
    import PlayersCampaignIgp from "./PlayersCampaignIgp.svelte";
    import ListCampaignIgp from "./ListCampaignIgp.svelte";

    export let adapter; // ProviderAdapter
    export let icons;

    let failedPlayersMap = new Map();
    let isNew = false, campaign = makeEmptyCampaign(), selectedClient = "", campaignType = "";
    let selectionMode = "none"; $: selectionMode = campaignType === "SLOT" ? "single" : (campaignType === "LIVE" ? "multiple" : "none");
    let creationFlow = null, isSaving = false, modalVersion = 0, lastPayload = null, playersPayload = null;
    let showPlayersCampaign = false, playersCampaign = null, listRef;

    function created() { campaign = makeEmptyCampaign(); isNew = true; campaignType = ""; selectedClient = ""; modalVersion++; }
    const closeCreate = () => (isNew = false);
    const addToEnd = (delta) => { campaign = coreAddToEnd(campaign, delta); };
    function openPlayersCampaign(row) {
        playersCampaign = mapRowToPlayersCampaign(row, { provider: adapter.providerCode, bonusPrefix: adapter.bonusPrefix });
        showPlayersCampaign = true;
    }

    const actions = {
        createCampaignDoc: (doc) => CampaignAPI.createCampaignIgp(doc),
        preflightProviderPlayers: async ({ campaignId, players }) => {
            try {
                const res = await adapter.savePlayer({
                    campaignId,
                    players,
                });
                return res.data;
            } catch (e) {
                console.error("V3 ERROR", e);
                throw e;
            }
        },
        addPlayer: async (campaignId, players) => {     
            return CampaignAPI.addPlayerToCampaignIgp(campaignId, players);
        },
        removePlayer: async (_campaignId, playerOrObj, promo) => {
            const playerId = typeof playerOrObj === "object" ? String(playerOrObj.playerId || "") : String(playerOrObj || ""); 
            try {
                const cancelPayload = adapter.mapRemovePlayer({ campaign: playersCampaign || lastPayload,playerId,playerId, payload: (typeof promo === "object" ? promo : null) });
                await adapter.deletePlayer(cancelPayload);
            } catch(error) {
                console.error("Error eliminando jugador en proveedor, intentando eliminar localmente");
                return{
                    ok:false,
                    error:error?.error
                }
            }
            return CampaignAPI.updatePlayerStatus((typeof playerOrObj === "object" ? playerOrObj.bonusCode : undefined) || playerId, 0);
        }
    };

    async function saveCampaign() {
        if (!lastPayload) { alert("No hay datos para guardar."); return; }
        try {
            isSaving = true;
            creationFlow = { stage: "creating", total: 0, added: 0, errors: 0 };
            await tick();
            const result = await saveCampaignFlow({
                actions,
                payload: lastPayload,
                players: playersPayload.players,
                bonusPrefix: adapter.bonusPrefix,
                genBonusIdV2,
                onStage: (stage, info) => {
                    const { done = 0, total = 0, errors = 0 } = info || {};
                    creationFlow = { stage, total, added: done, errors };
                }
            });
            await listRef?.refresh?.();
            closeCreate();
        } catch (e) {
            console.error(e);
            alert("Error creando campaña");
        } finally {
            isSaving = false;
            setTimeout(() => (creationFlow = null), 300);
        }
    }

    function handleErrorRemovingPlayer(e) {
        const { bonus } = e.detail;
        console.error("Error al eliminar al jugador:");

        alert(`No se pudo eliminar al jugador del bono`);
    }
    const api = {
        listByProvider: CampaignAPI.listByProviderIgp,
        cancelCampaign: CampaignAPI.cancelCampaignIgp,
        getById:        CampaignAPI.getCampaignByCampaignIdIgp,
        updateStatus:   CampaignAPI.updateCampaignStatus,
        updateStatusPlayer: (bonusOrId, status) => CampaignAPI.updatePlayerStatus(bonusOrId, status),
        providerDeletePlayer: ({ campaign, player }) => adapter.deletePlayer(adapter.mapRemovePlayer({ campaign, playerId: player.playerId, payload: player }))
    };
</script>

<ListCampaignIgp
    bind:this={listRef}
    provider={adapter.providerCode}
    {api}
    {icons}
    on:create={created}
    on:openplayers={async (e) => {
        const id = e.detail?.campaignId;
        let fresh = null;
        try { fresh = await listRef?.reconcileOne?.(id); } catch {}
        openPlayersCampaign(fresh || e.detail);
    }}
/>

{#if isNew}
    {#key modalVersion}
        <CreateCampainIgp
            {isNew}
            bind:campaign
            bind:campaignType
            bind:selectedClient
            manageClients="self"
            selectionMode={selectionMode}
            on:typechange={(e) => {
            selectionMode = e.detail.value === 'SLOT' ? 'single' : 'multi';
            }}
            integration={{
                provider: adapter.providerCode,
                providerName: adapter.providerName,
                maxDays: adapter.maxDays,
                validateClient: adapter.validateClient,
                getBetScales: adapter.getBetScales,
                demo: adapter.demo,
                bonusPrefix: adapter.bonusPrefix,
                idStrategy: adapter.idStrategy
            }}
            enabledTypes={adapter.types}
            saving={isSaving}
            {creationFlow}
            on:submit={(e) => { lastPayload = e.detail.payload; playersPayload = e.detail.players || [];}}
            on:close={closeCreate}
            on:save={saveCampaign}
            on:addtoend={(e) => addToEnd(e.detail)}
        />
    {/key}
{/if}

{#if showPlayersCampaign}
    <PlayersCampaignIgp
        campaign={playersCampaign}
        actions={actions}
        {adapter}
        getCampaignByCampaignId={CampaignAPI.getCampaignByCampaignIdIgp}
        autoRefetchOnOpen={false}
        demoConfig={adapter.demo}
        idStrategy={ adapter.idStrategy ?? adapter.playerIdStrategy ?? 'auto' }
        on:close={() => (showPlayersCampaign = false)}
        on:playersUpdated={(e) => {
        const { campaignId, playerList } = e.detail || {};
        listRef?.updateRowPlayers?.(campaignId, playerList);
    }}
        on:errorRemovingPlayer={handleErrorRemovingPlayer}
    />
{/if}
